export default __webpack_public_path__ + "static/media/phone1.4da1211a.png";